export default [
    {
        path: '',
        redirect: './class/classSituation'
    },
    {
        path: 'class',
        component: r => require.ensure([], () => r(require('@/views/details/home')), 'detail'),
        children: [
            {
                path: 'totalState/:classId?',
                name: 'totalState',
                component: r => require.ensure([], () => r(require('@/views/details/totalState')), 'detail'),
                meta: {
                    title: ''
                }
            },
            {
                path: 'classSituation/:classId?',
                name: 'classSituation',
                component: r => require.ensure([], () => r(require('@/views/details/classSituation')), 'detail'),
                meta: {
                    title: ''
                }
            },
            {
                path: 'personal/:classId?',
                name: 'personal',
                component: r => require.ensure([], () => r(require('@/views/details/personal')), 'detail'),
                meta: {
                    title: ''
                }
            }
        ]
    },
    {
        path: 'moreInfo',
        name: 'moreInfo',
        component: r => require.ensure([], () => r(require('@/views/details/moreInfo')), 'detail'),
        meta: {
            title: ''
        }
    }
]




// WEBPACK FOOTER //
// ./src/router/details.js